/* eslint-disable @typescript-eslint/no-explicit-any */

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'cellComponentRowDataPipe' })
export class CellComponentRowDataPipe implements PipeTransform {
  transform<T>(
    value: ((rowData: T, loading: boolean) => Record<string, any>) | undefined,
    rowData: T,
    loading: boolean,
  ): Record<string, any> {
    if (!value) {
      return {};
    }
    return value(rowData, loading) ?? {};
  }
}
